import { useEffect, useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import { PayTypeIdSelect } from "../selects/PayTypeIdSelect";
import { PayrollPeriodIdSelectFilter } from "../selects/PayrollPeriodIdSelectFilter";
import { CreateTableForUpload } from "./CreateTableForUpload";

export function UploadForm({
	isOpen,
	onClose,
	payrollPeriodId,
	payTypeId,
	setPayrollPeriodId,
	setPayTypeId,
	type,
	data_temp,
	setData_temp,
	handleFileUpload,
	handleFinalFileUpload,
}) {
	const handleClose = () => {
		onClose();
		setPayrollPeriodId("");
		setPayTypeId("");
		setFiles("");
		setData_temp([]);
	};

	const [files, setFiles] = useState([]);
	const [currentFiles, setCurrentFiles] = useState([]);
	const [hasNoError, setHasNoError] = useState(false);

	useEffect(() => {
		if (data_temp.length > 0) {
			const _errorData = data_temp.filter((i) => i.errors.length > 0);

			if (_errorData.length <= 0) {
				setHasNoError(true);
			} else {
				setHasNoError(false);
			}
		}
	}, [data_temp]);

	const handleBrowse = (e) => {
		const fileList = Array.from(e.target.files);
		setFiles(fileList);
	};
	const handleDrop = (e) => {
		e.preventDefault();
		const fileList = Array.from(e.dataTransfer.files);
		setFiles(fileList);
		e.currentTarget.style.backgroundColor = "white";
	};
	const handleDragOver = (e) => {
		e.preventDefault();
		e.currentTarget.style.backgroundColor = "#bdbdbd7d";
	};
	const handleDragOut = (e) => {
		e.preventDefault();
		e.currentTarget.style.backgroundColor = "white";
	};
	const clearFiles = () => {
		// Clear the files state
		setFiles([]);
		// Reset the value of the file input
		document.getElementById("fileInput").value = "";
		setData_temp([]);
	};

	useEffect(() => {
		if (currentFiles !== files) {
			setCurrentFiles(files);
			handleFileUpload(files, type, payrollPeriodId, payTypeId);
		}
	}, [files, handleFileUpload, currentFiles, type, payrollPeriodId, payTypeId]);

	const [errorState, setErrorState] = useState(false);

	const submit = (e) => {
		if (!payrollPeriodId || !payTypeId) {
			setErrorState(true);
			return;
		}

		const dataToPass = data_temp?.map((item) => {
			return {
				...item,

				// Override original values
				payTypeId: payTypeId,
				payrollPeriodId: payrollPeriodId,
			};
		});
		
		handleFinalFileUpload(dataToPass, type);
		handleClose();
		setErrorState(false);
	};

	const [currentPage, setCurrentPage] = useState(1);
	var header = [
		"Employee Id",
		"Employee Name",
		"Reason Code",
		"Amount",
		"Error",
	];
	var accessor = [
		"employeePersonalInformationEmployeeId",
		"employeePersonalInformationFullName",
		"payrollReasonCodePayrollCode",
		"amount",
		"errors",
	];
	var headerAdjustment = [
		"Employee Id",
		"Employee Name",
		"Reason Code",
		"Amount",
		"Number Of Hours",
		"Adjustment Date",
		"Reference Id",
		"Error",
	];
	var accessorAdjustment = [
		"employeePersonalInformationEmployeeId",
		"employeePersonalInformationFullName",
		"payrollReasonCodePayrollCode",
		"amount",
		"noOfHours",
		"adjustmentDate",
		"referenceId",
		"errors",
	];

	return (
		<>
			<div className={`modal-overlay ${isOpen ? "open" : ""}`}>
				{isOpen && (
					<div className="modal">
						<div className="popUp-header row">
							<div className="popUp-title">
								<h3 style={{ color: "#668fca" }}>{"Upload " + type}</h3>
							</div>
							<div className="popUp-close">
								<CloseIcon onClick={() => handleClose()} />
							</div>
						</div>
						<div
							className="popUp-body user-template-body"
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
							}}
						>
							<div className="popUp-item info-item column">
								<div className="info-item-label">Pay Type</div>
								<div className="info-item-input">
									<PayTypeIdSelect
										payTypeId={payTypeId}
										setPayTypeId={setPayTypeId}
									/>
								</div>
								<span
									style={{
										visibility: !payTypeId && errorState ? "visible" : "hidden",
										color: "#ff6565",
										fontSize: "12px",
									}}
								>
									Please fill up this field
								</span>
							</div>
							<div className="popUp-item info-item column">
								<div className="info-item-label">Payroll Period</div>
								<div className="info-item-input">
									<PayrollPeriodIdSelectFilter
										payrollPeriodId={payrollPeriodId}
										setPayrollPeriodId={setPayrollPeriodId}
										payTypeId={payTypeId}
									/>
								</div>
								<span
									style={{
										visibility:
											(!payrollPeriodId && errorState) || !payTypeId
												? "visible"
												: "hidden",
										color: "#ff6565",
										fontSize: "12px",
									}}
								>
									{!payTypeId
										? "Please select Pay Type first"
										: "Please fill up this field"}
								</span>
							</div>
						</div>
						<div>
							<label htmlFor="fileInput" className="browse">
								Browse...
							</label>
							<input
								type="file"
								id="fileInput"
								onChange={(e) => handleBrowse(e)}
								style={{ display: "none" }}
							/>
							<div
								id="drop-files-here"
								onDrop={(e) => handleDrop(e)}
								onDragOver={(e) => handleDragOver(e)}
								onDragLeave={(e) => handleDragOut(e)}
								style={{
									border: "2px dashed #ccc",
									borderRadius: "5px",
									padding: "20px",
									marginTop: "10px",
									textAlign: "center",
								}}
							>
								Drop files here
							</div>
							{files.length > 0 && (
								<div style={{ border: "1px solid #97979745", padding: "10px" }}>
									<span>Uploaded File:</span>
									<ul>
										{files.map((file, index) => (
											<span key={index}>{file.name}</span>
										))}
									</ul>
									<div
										className="buttons row"
										style={{ display: "flex", justifyContent: "end" }}
									>
										<button
											id="add-family"
											className="cancel row"
											onClick={() => clearFiles()}
											style={{ marginRight: "5px" }}
										>
											CLEAR
										</button>
									</div>
								</div>
							)}
						</div>
						{files.length > 0 && (
							<>
								{hasNoError ? (
									<>
										<div
											style={{
												marginTop: "10px",
												padding: "10px",
												backgroundColor: "#4cc92a",
												color: "white",
											}}
										>
											Data is valid.
										</div>
									</>
								) : (
									<>
										<div
											style={{
												marginTop: "10px",
												padding: "10px",
												backgroundColor: "#ce3434",
												color: "white",
											}}
										>
											Cannot upload with error.
										</div>
									</>
								)}
								<div
									className="employeesTab-tab upload-preview-tab"
									style={{ marginTop: "10px" }}
								>
									<div
										id="container1 table-uploads"
										className="employeesTab-table container"
									>
										<CreateTableForUpload
											dataList={data_temp}
											dataHeader={
												type === "Other Adjustments" ? headerAdjustment : header
											}
											dataAccessor={
												type === "Other Adjustments"
													? accessorAdjustment
													: accessor
											}
											currentPage={currentPage}
											setCurrentPage={setCurrentPage}
										/>
									</div>
								</div>
								<div
									className="buttons row"
									style={{
										justifyContent: "end",
										padding: "40px 40px 20px 40px",
									}}
								>
									{hasNoError && (
										<button
											id="add-family"
											className="save row"
											onClick={(e) => submit(e)}
											style={{ marginRight: "5px" }}
										>
											UPLOAD
										</button>
									)}
									<button
										id="add-family"
										className="cancel row"
										style={{
											marginRight: "5px",
											height: "34px",
											borderRadius: "3px",
										}}
										onClick={() => handleClose()}
									>
										CANCEL
									</button>
								</div>
							</>
						)}
					</div>
				)}
			</div>
		</>
	);
}